import { render, staticRenderFns } from "./PlsStock.vue?vue&type=template&id=42da0597&scoped=true"
import script from "./PlsStock.vue?vue&type=script&lang=js"
export * from "./PlsStock.vue?vue&type=script&lang=js"
import style0 from "./PlsStock.vue?vue&type=style&index=0&id=42da0597&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42da0597",
  null
  
)

export default component.exports